import HousingCompanyService from "./HousingCompanyService";
import AccountService from "./AccountService";
import AuthenticationService from "./AuthenticationService";
import MessageService from "./MessageService";
import MaterialService from "./MaterialService";
import axios from "axios";
import { ResponseBase } from "src/models";
import SaunaService from "./SaunaService";
import ParkingService from "./ParkingService";
import UserService from "./UserService";
import NoticeService from "./NoticeService";
import RequestService from "./RequestService";

export interface IService {
    authentication: AuthenticationService;
    housingCompany: HousingCompanyService;
    account: AccountService;
    message: MessageService;
    material: MaterialService;
    sauna: SaunaService;
    parking: ParkingService;
    user: UserService;
    notice: NoticeService;
    request: RequestService;
}

export default class Service implements IService {
    protected apiUrl: string;
    protected readonly axios: any;

    private authenticationService: AuthenticationService;
    private housingCompanyService: HousingCompanyService;
    private accountService: AccountService;
    private messageService: MessageService;
    private materialService: MaterialService;
    private saunaService: SaunaService;
    private parkingService: ParkingService;
    private userService: UserService;
    private noticeService: NoticeService;
    private requestService: RequestService;

    public constructor(apiUrl: string, onUnauthenticated: () => void, onError: (res: ResponseBase) => void) {
        this.apiUrl = apiUrl;
        axios.defaults.baseURL = apiUrl;

        axios.interceptors.request.use(
            req => {
                const authToken = localStorage.getItem("authToken");
 
                if (authToken)
                    req.headers.Authorization = `Bearer ${authToken}`;
                
                return req;
            },
            error => Promise.reject(error));

        axios.interceptors.response.use(
            res => {
                if (onError) {
                    const response = res.data as ResponseBase;
                    onError(response);
                }

                return res;
            },
            error => {
                console.log(error);
                if (error.status === 401 && onUnauthenticated)
                    onUnauthenticated();
            });

        this.authenticationService = new AuthenticationService();
        this.accountService = new AccountService();
        this.housingCompanyService = new HousingCompanyService();
        this.messageService = new MessageService();
        this.materialService = new MaterialService();
        this.saunaService = new SaunaService();
        this.parkingService = new ParkingService();
        this.userService = new UserService();
        this.noticeService = new NoticeService();
        this.requestService = new RequestService();
    }

    get authentication(): AuthenticationService { return this.authenticationService; }
    get housingCompany(): HousingCompanyService { return this.housingCompanyService; }
    get account(): AccountService { return this.accountService; }
    get message(): MessageService { return this.messageService; }
    get material(): MaterialService { return this.materialService; }
    get sauna(): SaunaService { return this.saunaService; }
    get parking(): ParkingService { return this.parkingService; }
    get user(): UserService { return this.userService; }
    get notice(): NoticeService { return this.noticeService; }
    get request(): RequestService { return this.requestService; }
}
